import Billing from "@/pages/settings/Billing";
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "./ui/alert-dialog";
import { Button } from "./ui/button";
import { X } from "@phosphor-icons/react";

function CheckoutAlert({ inline = false }: { inline?: boolean }) {
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild type="button">
        {inline ? (
          <Button
            type="button"
            variant="link"
            size="sm"
            className="h-auto p-0 text-sm"
          >
            Subscribe for unlimited
          </Button>
        ) : (
          <Button
            type="button"
            variant="secondary"
            size="default"
            className="rounded-full h-fit max-w-full text-sm w-full @lg:w-fit"
          >
            <span className="truncate">Subscribe for unlimited access</span>
          </Button>
        )}
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            Subscribe
            <AlertDialogCancel asChild>
              <Button
                variant="ghost"
                className="absolute p-2 border-none top-2 right-2 !w-12 !h-12"
                type="button"
                size={"icon"}
              >
                <span className="sr-only">Close</span>
                <X />
              </Button>
            </AlertDialogCancel>
          </AlertDialogTitle>
          <AlertDialogDescription className="max-h-[80vh] overflow-y-auto">
            <Billing />
          </AlertDialogDescription>
        </AlertDialogHeader>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export default CheckoutAlert;
